<template>

       <div class="shop-wrapper">

        <!-- Search overlay -->
       
        <!-- Main section -->
        <div id="account-page" class="section">
            <!-- Container -->
            <div class="container">

                <!-- Account Layout -->
                <div class="columns account-header">
                    <div class="column main-column is-tablet-landscape-padded">
                        <!-- Title -->
                        <div class="account-title">
                            <h2>CUENTA</h2>
                            <img :src="require('../../assets/images/icon-bambi.png')" alt="brand-filigrane" class="brand-filigrane">
                        </div>

                        <!-- Account tabs -->
                        <div class="tabs account-tabs">
                            <navigation></navigation>
                        </div>

                        <!-- Account layout -->
                        <div id="account-main" class="columns is-account-grid is-multiline">
                            <!--Loader-->
                            <div class="account-loader is-active" v-show="loading">
                                <div class="loader is-pulled is-loading"></div>
                            </div>

                            <div class="column is-5" v-show="!loading">
                                <!-- User card -->
                                <div class="flat-card profile-card is-auto">
                                    <div class="card-body">
                                        <div class="profile-image">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                        </div>
                                        <div class="username has-text-centered">
                                            <span id="full-name">{{customer.nombre_cliente}}</span>
                                            <small id="full-email">{{customer.email_fc_cliente}}</small>
                                        </div>
                                    </div>
                                    <div class="profile-footer has-text-centered">
                                        <span class="achievement-title">nro cliente</span>
                                        <div class="count">
                                            {{customer.Id_cliente}}
                                        </div>
                                    </div>
                                    <div class="profile-footer has-text-centered">
                                        <span class="achievement-title">CUIT cliente</span>
                                        <div class="count">
                                            {{customer.cuit_cliente}}
                                        </div>
                                    </div>
                                </div>
                                <!-- Gold Customer card -->
                                <!-- <div class="flat-card profile-info-card is-auto is-dark is-achievement">
                                    <div class="card-body"> -->
                                        <!-- <img src="./Nephos __ Modern Bulma Ecommerce App and Dashboard_files/nephos-gold.svg"
                                            alt=""> -->
                                        <!-- <div class="achievement-name">
                                            <span class="is-gold">Nephos Gold Customer</span>
                                            <span>As a Gold Customer, you have a permanent 10% discount on all your
                                                purchases.</span>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- Referal card -->
                                <!-- <div class="flat-card profile-info-card is-auto is-dark is-achievement">
                                    <div class="card-body"> -->
                                        <!-- <img src="./Nephos __ Modern Bulma Ecommerce App and Dashboard_files/nephos-referral.svg"
                                            alt=""> -->
                                        <!-- <div class="achievement-name">
                                            <span class="is-green">Nephos Referer</span>
                                            <span>You have referred <b>30+</b> customers. You get a 2.5% discount on all
                                                your purchases.</span>
                                        </div>
                                    </div>
                                </div> -->
                            </div>

                            <!-- Details -->
                            <div class="column is-7">
                                <!-- Billing Address -->
                                <div id="account-billing-address" class="flat-card profile-info-card is-auto">
                                    <!-- Title -->
                                    <div class="card-title">
                                        <h3>Detalle de Cliente</h3>
                                       </div>
                                    <!-- Billing Address -->
                                    <div class="card-body">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <div class="info-block">
                                                    <span class="label-text">Domicilio</span>
                                                    <span class="label-value address1">{{customer.domicilio_cliente}}</span>
                                                </div>

                                                <div class="info-block">
                                                    <span class="label-text">Localidad</span>
                                                    <span class="label-value city">{{customer.localidad_cliente}}</span>
                                                </div>

                                                <div class="info-block">
                                                    <span class="label-text">Provincia</span>
                                                    <span class="label-value state">{{customer.pcia_cliente}}</span>
                                                </div>
                                            </div>

                                            <div class="column is-6">
                                                <div class="info-block">
                                                    <span class="label-text">Teléfono</span>
                                                    <span class="label-value address2">{{customer.telefono_cliente}}</span>
                                                </div>

                                                <div class="info-block">
                                                    <span class="label-text">Correo</span>
                                                    <span class="label-value postal-code">{{customer.email_fc_cliente}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /Address Form -->
                                </div>

                                <div class="flat-card profile-info-card is-auto">
                                    <!-- Title -->
                                    <div class="card-title">
                                        <h3>Detalle de Usuario</h3>

                                        <div class="edit-account has-simple-popover popover-hidden-mobile"
                                            data-content="Edit Account" data-placement="top">

                                            <b-tooltip label="Editar Datos de Usuario" position="is-left" type="is-dark">
                                                <router-link tag="a" :to="{name: 'account.form'}">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                        class="feather feather-settings feather-icons">
                                                        <circle cx="12" cy="12" r="3"></circle>
                                                        <path
                                                            d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z">
                                                        </path>
                                                    </svg>
                                                </router-link>
                                            </b-tooltip>
                                        </div>
                                    </div>
                                    <!-- Contact Info -->
                                    <div class="card-body">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <div class="info-block">
                                                    <span class="label-text">Nombre</span>
                                                    <span id="account-first-name" class="label-value">{{user.name}}</span>
                                                </div>

                                                <div class="info-block">
                                                    <span class="label-text">Email</span>
                                                    <span id="account-email" class="label-value">{{user.email}}</span>
                                                </div>
                                            </div>

                                            <div class="column is-6">
                                                <div class="info-block">
                                                    <span class="label-text">Apellido</span>
                                                    <span id="account-last-name" class="label-value">{{user.lastname}}</span>
                                                </div>

                                                <div class="info-block">
                                                    <span class="label-text">Teléfono</span>
                                                    <span id="account-phone-number" class="label-value">{{user.celular}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Background BAMBI LOGO -->
                                    <img :src="require('../../assets/images/icon-bambi.png')" alt="brand-filigrane" class="card-bg">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /Container -->
        </div>
        <!-- /Main section -->
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import navigation from '../components/navigation'

export default {
    name: 'profile',
    computed: {
        ...mapGetters({
            user: 'auth/user',
            errors: 'auth/errors',
            loading: 'auth/loading',
            customer: 'customer/customer'
        }),
    },
    components:{
        navigation
    }
}
</script>
